export type AssetsResponse = {
  userSubscription: {
    name: string,
    featuresByUser: string[],
    featuresByUserCountry: string[]
  }
}


export enum FeatureAsset {
  CONNECT = 'Connect',
  DATA_INBOX = 'DataInbox',
  DATA_INBOX_SOIL_TESTS = 'DataInboxSoilTests',
  FIX_IT_TOOL = 'FixItTool',
  MANUAL_SCRIPTING = 'ManualScripting',
  OTC = 'OTC',
  YIELD_ANALYSIS = 'YieldAnalysis'
}